// This should come from the database

const menu = (role) => {
  const menuItems = [
    {
      id: 1,
      label: "Candidaturas",
      icon: "UserMultiple16",
      roles: ["200", "201", "202", "203"],
      items: [
        {
          id: 1.1,
          label: "Registar",
          link: "/admin/create-candidature",
          roles: ["201", "202", "203"],
        },
        {
          id: 1.2,
          label: "Consultar",
          link: "/admin/candidatures",
          roles: ["200", "202", "203"],
        },
        {
          id: 1.2,
          label: "Consultar",
          link: "/admin/candidature/redirect",
          roles: ["201"],
        },
        {
          id: 1.3,
          label: "Por Oficial de Inscrição",
          link: "/admin/enrollment-officers",
          roles: ["200", "202"],
        },
        {
          id: 1.4,
          label: "Por Distrito",
          link: "/admin/candidatures-by-district",
          roles: ["200", "202"],
        },
        {
          id: 1.5,
          label: "Elegibilidade Janela 2",
          link: "/admin/window2-elegibilidade",
          roles: ["200"],
        },
        {
          id: 1.6,
          label: "Períodos de Submissão",
          link: "/admin/periodos-de-submissao",
          roles: ["200"],
        },
      ],
    },
    {
      id: 2,
      label: "Planos de Negócio",
      icon: "UserMultiple16",
      roles: ["200", "202", "203", "204", "207", "201"],
      items: [
        {
          id: 2.1,
          label: "Registar",
          link: "/admin/registar-plano-de-negocio",
          roles: ["201"],
        },
        {
          id: 2.2,
          label: "Consultar",
          link: "/admin/planos-de-negocio",
          roles: ["200", "202", "203", "207"],
        },
        {
          id: 2.3,
          label: "Painel de Júri",
          link: "/admin/painel-de-juri-planos-de-negocio",
          roles: ["200", "202"],
        },
        {
          id: 2.4,
          label: "Avaliação",
          link: "/admin/planos-de-negocio-do-juri",
          roles: ["204"],
        },
        {
          id: 2.5,
          label: "Ranking",
          link: "/admin/ranking-de-planos-de-negocio",
          roles: ["200", "202"],
        },
        // {
        //   id: 2.3,
        //   label: "Meu Plano de Negócio",
        //   link: "/admin/meu-plano-de-negocio",
        //   roles: ["2"],
        // },
      ],
    },
    {
      id: 6,
      label: "Relatórios",
      icon: "UserMultiple16",
      roles: ["200", "202"],
      items: [
        {
          id: 6.1,
          label: "Planos de Negócio",
          link: "/admin/relatorios",
          roles: ["200", "202"],
        },
      ],
    },
    {
      id: 5,
      label: "Utilizadores",
      icon: "UserMultiple16",
      roles: ["200", "202", "203", "204"],
      items: [
        {
          id: 5.1,
          label: "Registar",
          link: "/admin/registar-utilizador",
          roles: ["200"],
        },
        {
          id: 5.2,
          label: "Consultar",
          link: "/admin/utilizadores",
          roles: ["200"],
        },
        // {
        //   id: 5.3,
        //   label: "Minha conta",
        //   link: "/admin/minha-conta",
        //   roles: ["200", "201", "202", "203", "204"],
        // },
      ],
    },
  ];

  const userMenu = menuItems.filter((m) => m.roles.includes(role));
  userMenu.forEach((menu) => {
    menu.items = menu.items.filter((mi) => mi.roles.includes(role));
  });

  return userMenu;
};

export default menu;
